/* ==========================================================================
   MAISON REVØRA — „La Maison“ (/pages/uber-uns) + Service-/Rechtsseiten (/pages/…)
   Aus dem Vorschau-Prototyp (src/page-maison.js) übernommen. Nur eigene Klassen .rvm-.
   Fakten ausschließlich wie in der Vorlage bzw. aus RV.D.fakten / Produkt- und Kollektionsdaten.
   Service-Seiten: Liquid (sections/rvm-service) rendert Rahmen + UNVERÄNDERTES Live-Snippet;
   hier nur Darstellung (FAQ-Akkordeons + Suche, Tabellenrahmen, Chips) – Wortlaut bleibt.
   ========================================================================== */
(function () {
  "use strict";
  const D = RV.D, F = D.fakten, B = D.banner || {}, esc = RV.esc;
  const EN = !!(RV.cfg && RV.cfg.locale === "en");
  const T = (de, en) => (EN ? en : de);
  const KI = T(", KI-generierte Abbildung", ", AI-generated image");
  const mq = (q) => !!(window.matchMedia && window.matchMedia(q).matches);
  const still = () => mq("(prefers-reduced-motion: reduce)") || document.documentElement.classList.contains("rv-static");
  const roman = (n) => ["", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X"][n] || String(n);

  /* Bild aus den Produktdaten (Alt-Text unverändert) */
  const pimg = (h, color, kind) => {
    const p = RV.prod(h);
    if (!p || !p.c.length) return null;
    const c = p.c.find((x) => x.n === color) || p.c[0];
    const im = c.im.find((i) => i.k === kind) || c.im[c.card] || c.im[0];
    return im ? { p, c, im } : null;
  };
  /* Banner mit Art-Direction: Desktop-Motiv + mobiles 4:5-Motiv */
  const pic = (b, o = {}) =>
    `<picture class="${o.cls || ""}"><source media="(max-width:760px)" srcset="${RV.srcset(b.m, [480, 720, 960, 1200])}" sizes="100vw">${RV.imgTag(b.d, { w: 1600, sizes: o.sizes || "100vw", alt: o.alt || "", eager: !!o.eager, ws: [960, 1280, 1600, 2000, 2400] })}</picture>`;
  const bimg = (b, o) => (b && b.m ? RV.imgTag(b.m, o) : "");

  /* ---------- Parallax (sanft, nur ohne reduce-motion) ---------- */
  let parEls = [], parRaf = 0;
  const parTick = () => {
    parRaf = 0;
    const vh = window.innerHeight;
    parEls.forEach((el) => {
      const r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      const f = +el.dataset.par || 0.1;
      const prog = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      const max = r.height * 0.065;
      const y = Math.max(-max, Math.min(max, -prog * f * r.height));
      el.style.transform = `translate3d(0,${y.toFixed(1)}px,0)`;
    });
  };
  const onPar = () => { if (!parRaf) parRaf = requestAnimationFrame(parTick); };
  const parStop = () => {
    window.removeEventListener("scroll", onPar);
    window.removeEventListener("resize", onPar);
    if (parRaf) cancelAnimationFrame(parRaf);
    parRaf = 0;
    parEls = [];
  };
  const parStart = (root) => {
    parStop();
    if (still()) return;
    parEls = Array.from(root.querySelectorAll("[data-par]"));
    if (!parEls.length) return;
    window.addEventListener("scroll", onPar, { passive: true });
    window.addEventListener("resize", onPar);
    parTick();
  };

  /* ==========================================================================
     LA MAISON
     ========================================================================== */
  const collDesc = (h, fallback) => {
    const c = RV.coll(h);
    return c && c.d ? c.d.replace(/\s+/g, " ").trim() : fallback;
  };
  const firstSentence = (s) => (s.match(/^.*?[.!?](\s|$)/) || [s])[0].trim();

  function maisonHTML() {
    const tick = `<span class="rvm-tick rv-stripe rv-stripe--thin" aria-hidden="true"></span>`;

    /* Kapitel II: zwei Druck-Details (verschiedene Farben) */
    const d1 = pimg("cin-cin", "French Navy", "detail");
    const d2 = pimg("la-dolce-vita", "Natural Raw", "detail");
    /* Le Signe: flache Vorderansicht mit dem kleinen RØ */
    const fr = pimg("cheers", "French Navy", "front");

    const azurD = firstSentence(collDesc("azur-club", T("Statement-Shirts mit großflächigem Rückenprint.", "Statement shirts with a large back print.")));
    const rivD = firstSentence(collDesc("riviera", T("Küstensommer und Süditalien aufs Shirt.", "Coastal summer and southern Italy on a shirt.")));
    const winD = firstSentence(collDesc("winter", T("Die REVØRA-Winterlinie.", "The REVØRA winter line.")));

    const chap = (id, n, kicker, title, body, media, mod) => `
      <article class="rvm-ch rvm-ch--${mod}" id="${id}">
        <div class="rvm-ch__media">${media}</div>
        <div class="rvm-ch__txt">
          <div class="rvm-ch__num" aria-hidden="true" data-reveal="fade"><span>${roman(n)}</span></div>
          <div class="rv-eyebrow" data-reveal>${kicker}</div>
          <h3 class="rvm-ch__t" data-reveal style="--d:.08s">${title}</h3>
          <div class="rvm-ch__body" data-reveal style="--d:.16s">${body}</div>
        </div>
      </article>`;

    const ch1 = chap("rvm-coton", 1, T("Chapitre I · Der Stoff", "Chapitre I · The fabric"), `Le <span class="rv-it">Coton</span>`,
      `<p class="rv-lead">${T("Gekämmte Baumwolle mit 220&nbsp;g/m², oversized geschnitten. Rundhals mit Nackenband, eingesetzte Ärmel — das Shirt hängt gerade und behält seine Form.",
        "Combed cotton at 220&nbsp;g/m², cut oversized. Crew neck with neck tape, set-in sleeves — the shirt hangs straight and keeps its shape.")}</p>
       <dl class="rvm-spec">
         <div><dt>${T("Material", "Material")}</dt><dd>${T("100&nbsp;% Baumwolle, gekämmt", "100&nbsp;% cotton, combed")}</dd></div>
         <div><dt>${T("Ware", "Fabric")}</dt><dd>Single Jersey</dd></div>
         <div><dt>${T("Grammatur", "Weight")}</dt><dd>220&nbsp;g/m²</dd></div>
         <div><dt>${T("Kragen", "Collar")}</dt><dd>${T("Rundhals mit Nackenband", "Crew neck with neck tape")}</dd></div>
         <div><dt>${T("Schnitt", "Fit")}</dt><dd>Oversized, unisex</dd></div>
       </dl>
       <p class="rv-small">${T("Angaben für die Oversized Shirts. Material und Schnitt von Hoodies, Sweatshirts, Longsleeves und Jacken stehen in der jeweiligen Produktbeschreibung.",
        "Details for the oversized shirts. Material and fit of hoodies, sweatshirts, longsleeves and jackets are listed in each product description.")}</p>
       <a class="rv-link" href="${RV.href.c("t-shirts")}">${T("Alle Shirts entdecken", "Discover all shirts")}</a>`,
      `<div class="rvm-ch__frame rv-ph" data-reveal="scale"><div class="rvm-par" data-par=".12">${bimg(B.beach, { w: 1200, sizes: "(max-width:900px) 92vw, 46vw", alt: T("REVØRA Life Comes In Waves Shirt, Rückansicht am Meer", "REVØRA Life Comes In Waves shirt, back view by the sea") + KI, ws: [480, 720, 960, 1200] })}</div></div>
       <div class="rvm-ch__cap"><span>Fig. I</span><span>220&nbsp;g/m² · Single Jersey</span></div>`, "a");

    const ch2 = chap("rvm-impression", 2, T("Chapitre II · Der Druck", "Chapitre II · The print"), `L’<span class="rv-it">Impression</span>`,
      `<p class="rv-lead">${T("Das große Motiv auf dem Rücken und das kleine „RØ“ vorne entstehen im Direktdruck (DTG) — nach deiner Bestellung, in Deutschland.",
        "The large motif on the back and the small “RØ” on the front are made by direct-to-garment printing (DTG) — after you order, in Germany.")}</p>
       <ol class="rvm-flow">
         <li><span class="rvm-flow__n">01</span><b>${T("Du bestellst", "You order")}</b><small>${T("Motiv, Farbe, Größe.", "Motif, colour, size.")}</small></li>
         <li><span class="rvm-flow__n">02</span><b>${T("Wir drucken", "We print")}</b><small>${T("Direktdruck in Deutschland, einzeln für dich.", "Direct printing in Germany, one by one for you.")}</small></li>
         <li><span class="rvm-flow__n">03</span><b>${T("Es reist", "It travels")}</b><small>${T("Versand in der Regel innerhalb von 1–2 Werktagen.", "Usually dispatched within 1–2 working days.")}</small></li>
       </ol>
       <p class="rvm-ch__quote">${T("Kein Lager.", "No stock.")} <span class="rv-it">${T("Keine Restposten.", "No leftovers.")}</span></p>`,
      `${d1 ? `<div class="rvm-dip">
          <a class="rvm-dip__a rv-ph" href="${RV.href.p(d1.p.h, d1.c.n)}" data-reveal="scale">${RV.imgTag(d1.im.u, { w: 1000, sizes: "(max-width:900px) 84vw, 40vw", alt: d1.im.a, ws: [600, 800, 1000, 1400] })}</a>
          ${d2 ? `<a class="rvm-dip__b rv-ph" href="${RV.href.p(d2.p.h, d2.c.n)}" data-reveal style="--d:.2s">${RV.imgTag(d2.im.u, { w: 600, sizes: "(max-width:900px) 44vw, 18vw", alt: d2.im.a, ws: [360, 600, 900] })}</a>` : ""}
        </div>
        <div class="rvm-ch__cap"><span>Fig. II</span><span>${esc(RV.splitTitle(d1.p)[0])} · ${esc(d1.c.n)}${d2 ? ` &nbsp;/&nbsp; ${esc(RV.splitTitle(d2.p)[0])} · ${esc(d2.c.n)}` : ""}</span></div>` : ""}`, "b");

    /* Versand-Etikett: Express ist im Shop derzeit nicht aktiv (Versandprofil, geprüft 16.10.) -> Zeile zeigt DHL statt „Express 4,99 €“ */
    const tag = `
      <div class="rvm-post" data-reveal="fade">
        <div class="rvm-tag">
          <span class="rvm-tag__hole" aria-hidden="true"></span>
          <div class="rvm-tag__hd"><span>Maison REVØRA</span><span>Hildesheim</span></div>
          <div class="rvm-tag__big">DE <i>·</i> AT <i>·</i> CH</div>
          <div class="rvm-tag__sub">${T("Standardversand kostenlos<br>ohne Mindestbestellwert", "Free standard shipping<br>no minimum order")}</div>
          <dl class="rvm-tag__rows">
            <div><dt>${T("Versand", "Shipping")}</dt><dd>${T("DHL · Tracking", "DHL · tracking")}</dd></div>
          </dl>
          <div class="rvm-tag__ft"><span class="rv-stripe rv-stripe--thin" aria-hidden="true"></span><span class="rvm-tag__mono" aria-hidden="true">${RV.monoSVG("currentColor", 3)}</span></div>
        </div>
      </div>`;
    const ch3 = chap("rvm-envoi", 3, T("Chapitre III · Der Weg zu dir", "Chapitre III · The way to you"), `L’<span class="rv-it">Envoi</span>`,
      `<p class="rv-lead">${esc(F.versand)}. ${T("Nach dem Versand erhältst du automatisch eine E-Mail mit Tracking-Link.", "Once shipped, you automatically receive an email with a tracking link.")}</p>
       <dl class="rvm-spec">
         <div><dt>${T("Deutschland", "Germany")}</dt><dd>${T("2–5 Werktage", "2–5 working days")} <span class="rv-muted">(${T("Mo–Fr", "Mon–Fri")})</span></dd></div>
         <div><dt>${T("Schweiz", "Switzerland")}</dt><dd>${T("3–10 Werktage", "3–10 working days")} <span class="rv-muted">(${T("Mo–Fr", "Mon–Fri")})</span></dd></div>
         <div><dt>${T("Versand", "Shipping")}</dt><dd>${T("DHL, Tracking per E-Mail", "DHL, tracking by email")}</dd></div>
         <div><dt>${T("Widerruf", "Withdrawal")}</dt><dd>${T("14 Tage ab Erhalt", "14 days from receipt")}</dd></div>
       </dl>
       <p class="rv-small">${T("Lieferzeit ab Bestellung, Druck und Versand inklusive. Rücksendekosten trägt der Kunde.", "Delivery time from order, printing and shipping included. Return shipping costs are paid by the customer.")}</p>
       <div class="rvm-links"><a class="rv-link" href="${RV.href.seite("versand-lieferung")}">${T("Versand &amp; Lieferung", "Shipping &amp; delivery")}</a><a class="rv-link" href="${RV.href.seite("ruckgabe-umtausch")}">${T("Rückgabe &amp; Umtausch", "Returns &amp; exchanges")}</a></div>`,
      tag, "c");

    const loupe = fr ? `
      <figure class="rvm-plate" data-reveal>
        <div class="rvm-plate__fig">
          <a class="rvm-plate__img" href="${RV.href.p(fr.p.h, fr.c.n)}">${RV.imgTag(fr.im.u, { w: 900, sizes: "(max-width:900px) 86vw, 42vw", alt: fr.im.a, ws: [540, 720, 900, 1200] })}</a>
          <svg class="rvm-plate__line" viewBox="0 0 100 100" aria-hidden="true"><g class="rvm-l-d"><line class="rvm-l-h" x1="65.5" y1="32.1" x2="81.1" y2="19.8"/><line x1="65.5" y1="32.1" x2="81.1" y2="19.8"/></g><g class="rvm-l-m"><line class="rvm-l-h" x1="64.1" y1="31" x2="69" y2="20.3"/><line x1="64.1" y1="31" x2="69" y2="20.3"/></g></svg>
          <span class="rvm-plate__ring" aria-hidden="true"></span>
          <div class="rvm-loupe" aria-hidden="true">${RV.imgTag(fr.im.u, { w: 1200, sizes: "(max-width:900px) 560px, 1000px", alt: "", ws: [600, 900, 1200, 1600] })}</div>
        </div>
        <figcaption class="rvm-plate__cap"><span>${T("Fig. IV — Das Brustzeichen", "Fig. IV — The chest mark")}</span><span>${esc(RV.splitTitle(fr.p)[0])} · ${esc(fr.c.n)}</span></figcaption>
      </figure>` : "";

    return `
    <div class="rvm">
      <!-- I. Hero -->
      <section class="rvm-hero" aria-label="La Maison">
        <div class="rvm-hero__media"><div class="rvm-par rvm-hero__par" data-par=".12">${bimg(B.terrasse, { w: 1200, eager: true, sizes: "(min-width:1000px) 54vw, 100vw", alt: T("REVØRA La Dolce Vita Shirt, Rückansicht auf einer Terrasse über dem Meer", "REVØRA La Dolce Vita shirt, back view on a terrace above the sea") + KI, ws: [480, 720, 960, 1200, 1600] })}</div></div>
        <div class="rvm-hero__shade" aria-hidden="true"></div>
        <div class="rvm-hero__panel">
          <div class="rvm-hero__in">
            <div class="rv-eyebrow" data-reveal="fade">Maison REVØRA · MMXXVI</div>
            <h1 class="rv-display rvm-hero__t" data-reveal style="--d:.12s">La <span class="rv-it">Maison</span></h1>
            <p class="rvm-hero__lead" data-reveal style="--d:.24s">${T("Ruhige Motive, groß auf dem Rücken. Gegründet in Hildesheim, nach deiner Bestellung in Deutschland bedruckt.", "Quiet motifs, large on the back. Founded in Hildesheim, printed in Germany after you order.")}</p>
          </div>
          <div class="rvm-hero__foot">
            <nav class="rvm-som" aria-label="${T("Inhalt dieser Seite", "On this page")}"><span class="rvm-som__k">Sommaire</span>
              <button type="button" data-go="rvm-coton"><i>I</i>Le Coton</button>
              <button type="button" data-go="rvm-impression"><i>II</i>L’Impression</button>
              <button type="button" data-go="rvm-envoi"><i>III</i>L’Envoi</button>
              <button type="button" data-go="rvm-mondes"><i>IV</i>Les Mondes</button>
              <button type="button" data-go="rvm-signe"><i>V</i>Le Signe</button></nav>
            <button type="button" class="rvm-cue" data-go="rvm-manifest" aria-label="${T("Weiter zum Manifest", "Continue to the manifesto")}"><span>${T("Entdecken", "Discover")}</span><i aria-hidden="true"></i></button>
          </div>
        </div>
      </section>

      <!-- II. Manifest -->
      <section class="rvm-mani rv-sec" id="rvm-manifest">
        <div class="rv-wrap">
          <div class="rvm-mani__mark" aria-hidden="true" data-reveal="fade">${RV.monoSVG("currentColor", 2.4)}</div>
          <div class="rv-eyebrow rv-center" data-reveal>${T("Manifest", "Manifesto")}</div>
          <blockquote class="rvm-mani__q" data-reveal style="--d:.1s"><p>${T(`REVØRA macht Shirts, die man <span class="rv-it">wirklich</span> anzieht.`, `REVØRA makes shirts you <span class="rv-it">actually</span> wear.`)}</p></blockquote>
          <div class="rvm-mani__cols">
            <p class="rvm-drop" data-reveal>${T("Keine lauten Logos, keine Trends, die nach einer Saison albern aussehen — sondern ruhige Motive auf gekämmter Baumwolle.", "No loud logos, no trends that look silly after one season — just quiet motifs on combed cotton.")}</p>
            <p data-reveal style="--d:.12s">${T("Motive, die etwas sagen, ohne zu schreien — ein Satz, eine Zitrone, ein Sonnenuntergang. Groß auf dem Rücken, klein vorne das „RØ“.", "Motifs that say something without shouting — a phrase, a lemon, a sunset. Large on the back, the small “RØ” on the front.")}</p>
          </div>
          <div class="rvm-mani__sig" data-reveal><span>${T(`<span class="rv-it">— Das</span> REVØRA <span class="rv-it">Team</span>`, `<span class="rv-it">— The</span> REVØRA <span class="rv-it">team</span>`)}</span><a class="rv-link rv-link--grow" href="${RV.href.seite("contact")}">${T("Kontakt", "Contact")}</a></div>
        </div>
      </section>

      <!-- III. Kapitel -->
      <section class="rvm-chaps" aria-labelledby="rvm-chaps-t">
        <div class="rv-wrap rvm-sechd rvm-sechd--c">
          <div class="rv-eyebrow" data-reveal>Les Chapitres</div>${tick}
          <h2 class="rv-h1" id="rvm-chaps-t" data-reveal style="--d:.08s">${T(`Drei Kapitel. Ein <span class="rv-it">Shirt</span>.`, `Three chapters. One <span class="rv-it">shirt</span>.`)}</h2>
          <p class="rv-lead" data-reveal style="--d:.16s">${T("Vom Stoff über den Druck bis zu deiner Tür.", "From the fabric to the print to your door.")}</p>
        </div>
        <div class="rv-wrap">${ch1}${ch2}${ch3}</div>
      </section>

      <!-- IV. Die drei Welten -->
      <section class="rvm-worlds" id="rvm-mondes" aria-labelledby="rvm-worlds-t">
        <div class="rv-wrap rvm-sechd">
          <div class="rv-eyebrow" data-reveal>Les Mondes</div>${tick}
          <h2 class="rv-h1" id="rvm-worlds-t" data-reveal style="--d:.08s">${T(`Drei Welten. Ein <span class="rv-it">Süden</span>.`, `Three worlds. One <span class="rv-it">South</span>.`)}</h2>
        </div>
        <a class="rvm-wide" href="${RV.href.c("winter")}" aria-label="${T("Winter entdecken", "Discover Winter")}">
          <div class="rvm-wide__media">${B.winter && B.winter.d ? pic(B.winter, { alt: T("REVØRA-Winterlinie an der Strandpromenade, Rückansicht", "REVØRA winter line on the seafront promenade, back view") + KI }) : ""}</div>
          <div class="rv-wrap rvm-wide__cap">
            <div class="rvm-wide__k"><span class="rvm-world__no">Monde I</span><span class="rv-eyebrow">Winter</span></div>
            <h3 class="rvm-world__t">Hiver <span class="rv-it">au Sud</span></h3>
            <p>${esc(winD)}</p>
            <span class="rv-btn rv-btn--ghost">${T("Winter entdecken", "Discover Winter")}</span>
          </div>
        </a>
        <div class="rv-wrap rvm-duo">
          <a class="rvm-world rvm-world--a" href="${RV.href.c("azur-club")}">
            <div class="rvm-world__media rv-ph" data-reveal="scale">${bimg(B.azur, { w: 960, sizes: "(max-width:760px) 100vw, 52vw", alt: T("REVØRA Allergic To Normal Shirt, Rückansicht in einer Altstadtgasse", "REVØRA Allergic To Normal shirt, back view in an old-town alley") + KI, ws: [480, 720, 960, 1200] })}</div>
            <div class="rvm-world__cap" data-reveal><span class="rvm-world__no">Monde II</span>
              <h3 class="rvm-world__t">Azur <span class="rv-it">Club</span></h3>
              <p>${esc(azurD)}</p><span class="rv-link">${T("Azur Club entdecken", "Discover Azur Club")}</span></div>
          </a>
          <a class="rvm-world rvm-world--b" href="${RV.href.c("riviera")}">
            <div class="rvm-world__media rv-ph" data-reveal="scale" style="--d:.12s">${bimg(B.riviera, { w: 800, sizes: "(max-width:760px) 100vw, 36vw", alt: T("REVØRA Sunshine Oranges Shirt, Rückansicht unter Orangenbäumen", "REVØRA Sunshine Oranges shirt, back view under orange trees") + KI, ws: [480, 720, 960, 1200] })}</div>
            <div class="rvm-world__cap" data-reveal><span class="rvm-world__no">Monde III</span>
              <h3 class="rvm-world__t"><span class="rv-it">Riviera</span></h3>
              <p>${esc(rivD)}</p><span class="rv-link">${T("Riviera entdecken", "Discover Riviera")}</span></div>
          </a>
        </div>
      </section>

      <!-- V. Le Signe -->
      <section class="rvm-signe rv-canvas" id="rvm-signe" aria-labelledby="rvm-signe-t">
        <div class="rv-stripe rvm-signe__stripe" aria-hidden="true"></div>
        <div class="rv-wrap rvm-signe__in">
          ${loupe}
          <div class="rvm-signe__txt">
            <div class="rvm-signe__crest" data-reveal="fade">${RV.crest()}</div>
            <div class="rv-eyebrow" data-reveal>Le Signe</div>
            <h2 class="rv-h1" id="rvm-signe-t" data-reveal style="--d:.08s">${T(`Zwei Buchstaben. <span class="rv-it">Ein Zeichen.</span>`, `Two letters. <span class="rv-it">One sign.</span>`)}</h2>
            <p class="rvm-signe__p" data-reveal style="--d:.16s">${T("Vorne auf der Brust jedes Shirts sitzt ein kleines „RØ“. Mehr braucht die Vorderseite nicht — das große Motiv gehört dem Rücken.", "A small “RØ” sits on the chest of every shirt. The front needs nothing more — the large motif belongs to the back.")}</p>
            <dl class="rvm-signe__dl" data-reveal style="--d:.22s"><div><dt>${T("Vorne", "Front")}</dt><dd>${T("das kleine RØ", "the small RØ")}</dd></div><div><dt>${T("Hinten", "Back")}</dt><dd>${T("das große Motiv", "the large motif")}</dd></div></dl>
            <a class="rv-btn rv-btn--line-light" href="${RV.href.c("t-shirts")}" data-reveal style="--d:.28s">${T("Shirts entdecken", "Discover shirts")}</a>
          </div>
        </div>
      </section>

      <!-- VI. Hildesheim · MMXXVI -->
      <section class="rvm-origin rv-sec" aria-labelledby="rvm-origin-t">
        <div class="rv-wrap">
          <div class="rvm-origin__top" data-reveal><span class="rv-eyebrow">Origine</span>${tick}</div>
          <div class="rvm-origin__mast" data-reveal="fade">
            <span class="rvm-origin__year" aria-hidden="true">MMXXVI</span>
            <h2 class="rvm-origin__city" id="rvm-origin-t"><span class="rv-it">Hildesheim</span></h2>
          </div>
          <div class="rvm-origin__row">
            <p class="rvm-origin__a" data-reveal>${T("Hier gegründet.<br>In&nbsp;Deutschland bedruckt.", "Founded here.<br>Printed in&nbsp;Germany.")}</p>
            <p class="rvm-origin__b" data-reveal style="--d:.1s">${T("Jedes Teil wird erst nach deiner Bestellung bedruckt – kein Lager, keine Restposten. Versand mit DHL nach Deutschland und in die Schweiz.", "Every piece is printed only after you order – no stock, no leftovers. Shipped with DHL to Germany and Switzerland.")}</p>
          </div>
        </div>
      </section>

      <!-- VII. Schluss -->
      <section class="rvm-cta" aria-labelledby="rvm-cta-t">
        <div class="rvm-cta__media rv-ph" data-reveal="scale">${bimg(B.aperitivo, { w: 1200, sizes: "(max-width:900px) 100vw, 50vw", alt: T("REVØRA Cin Cin Shirt in Black, Rückansicht auf einer abendlichen Terrasse", "REVØRA Cin Cin shirt in Black, back view on an evening terrace") + KI, ws: [600, 900, 1200, 1600] })}</div>
        <div class="rvm-cta__txt">
          <div class="rvm-cta__crest" data-reveal="fade">${RV.crest("LE CLUB · MAISON REVØRA · MMXXVI · ")}</div>
          <div class="rv-eyebrow" data-reveal>Le Club</div>
          <h2 class="rv-display rvm-cta__t" id="rvm-cta-t" data-reveal style="--d:.08s">À <span class="rv-it">bientôt</span></h2>
          <p class="rv-lead" data-reveal style="--d:.16s">${T("Die neuen Motive der Saison warten — jedes Teil wird erst für dich bedruckt.", "This season’s new motifs are waiting — every piece is printed just for you.")}</p>
          <div class="rvm-cta__btns" data-reveal style="--d:.24s"><a class="rv-btn" href="${RV.href.c("neu-eingetroffen")}">${T("Neu eingetroffen", "New arrivals")}</a><a class="rv-btn rv-btn--ghost" href="${RV.href.c("all")}">${T("Alle Teile", "All pieces")}</a></div>
          <ul class="rvm-cta__perks" data-reveal style="--d:.3s"><li>${esc(F.versand_kurz)}</li><li>${T("14 Tage Widerruf", "14-day withdrawal")}</li><li>${T("DHL mit Tracking", "DHL with tracking")}</li></ul>
        </div>
      </section>
    </div>`;
  }

  const goTo = (id) => {
    const t = document.getElementById(id);
    if (!t) return;
    t.scrollIntoView({ behavior: still() ? "auto" : "smooth", block: "start" });
  };

  RV.page("maison", {
    header: "over",
    render(el) {
      el.innerHTML = maisonHTML();
      const root = el.querySelector(".rvm");
      root.addEventListener("click", (e) => {
        const g = e.target.closest("[data-go]");
        if (g) { e.preventDefault(); goTo(g.dataset.go); }
      });
      parStart(root);
    },
    destroy() { parStop(); },
  });

  /* ==========================================================================
     SERVICE-SEITEN (Rahmen + Live-Snippet kommen aus sections/rvm-service.liquid)
     ========================================================================== */
  const EMOJI = /[\p{Extended_Pictographic}\u{1F1E6}-\u{1F1FF}\u{FE0F}\u{200D}\u{20E3}]/gu;
  const norm = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/ø/g, "o");

  /* Deko-Emojis entfernen (Wortlaut bleibt) */
  function stripEmoji(root) {
    const tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const texts = [];
    while (tw.nextNode()) texts.push(tw.currentNode);
    texts.forEach((n) => { const v = n.nodeValue.replace(EMOJI, ""); if (v !== n.nodeValue) n.nodeValue = v.replace(/^\s+/, ""); });
  }

  /* FAQ: .cat-Gruppen + .faq-item -> Akkordeons mit Suche (Text aus dem Live-Snippet) */
  function faqHTML(groups) {
    let k = 0;
    return `<div class="rvm-faq">
        <div class="rvm-faq__tools">
          <label class="rvm-faq__search">${RV.icon("search")}<input type="search" placeholder="${T("Frage suchen", "Search questions")}" aria-label="${T("FAQ durchsuchen", "Search the FAQ")}" autocomplete="off" data-faq-q></label>
          <button type="button" class="rv-link rv-link--grow rvm-faq__all" data-faq-all aria-pressed="false">${T("Alle öffnen", "Open all")}</button>
        </div>
        <nav class="rvm-faq__jump" aria-label="${T("Themen", "Topics")}">${groups.filter((g) => g.t).map((g, i) => `<button type="button" class="rv-chip" data-go="rvm-fg${i}">${g.t}</button>`).join("")}</nav>
        ${groups.map((g, gi) => `<section class="rvm-faq__grp" id="rvm-fg${gi}">
          ${g.t ? `<h2 class="rvm-faq__h"><span class="rvm-faq__no" aria-hidden="true">${roman(gi + 1)}</span>${g.t}</h2>` : ""}
          <div class="rvm-acc">${g.items.map((it) => { const i = k++; const open = i === 0; return `
            <div class="rvm-acc__it${open ? " is-open" : ""}" data-faq-it>
              <h3 class="rvm-acc__h"><button type="button" class="rvm-acc__b" id="rvm-q${i}" aria-expanded="${open}" aria-controls="rvm-a${i}"><span>${it.q}</span><i aria-hidden="true"></i></button></h3>
              <div class="rvm-acc__p" id="rvm-a${i}" role="region" aria-labelledby="rvm-q${i}"><div><div class="rvm-acc__in">${it.a}</div></div></div>
            </div>`; }).join("")}</div></section>`).join("")}
        <p class="rvm-faq__none" hidden>${T("Keine passende Frage gefunden. Schreib uns an", "No matching question found. Write to us at")} <a href="mailto:${esc(F.kontakt)}">${esc(F.kontakt)}</a>.</p>
      </div>`;
  }
  function faqBuild(doc) {
    const rp = doc.querySelector(".rp");
    if (!rp || !rp.querySelector(".faq-item")) return;
    const groups = [];
    let grp = null;
    Array.from(rp.children).forEach((n) => {
      if (n.classList.contains("cat")) { grp = { t: n.innerHTML.trim(), items: [] }; groups.push(grp); n.remove(); }
      else if (n.classList.contains("faq-item")) {
        const b = n.querySelector(".faq-q"), a = n.querySelector(".faq-a");
        if (b) { const ic = b.querySelector(".faq-icon"); if (ic) ic.remove(); }
        if (!grp) { grp = { t: "", items: [] }; groups.push(grp); }
        grp.items.push({ q: b ? b.innerHTML.trim() : "", a: a ? a.innerHTML : "" });
        n.remove();
      } else if (n.tagName === "SCRIPT") n.remove();
    });
    rp.insertAdjacentHTML("beforeend", faqHTML(groups));
  }

  /* Seiteninhalt (page.content): Inline-Styles weg, „Label: Wert“-Zeilen -> Liste, „1. …“ -> Schritte */
  function prepContent(doc) {
    const box = doc.querySelector(".rp--content");
    if (!box) return;
    const f = box.firstElementChild;
    if (f && f.tagName === "H1") f.remove();
    box.querySelectorAll("[style]").forEach((e) => e.removeAttribute("style"));
    box.querySelectorAll("p").forEach((p) => {
      const segs = p.innerHTML.split(/<br\s*\/?>/i).map((s) => s.trim()).filter(Boolean);
      if (segs.length < 2) return;
      const kv = segs.map((s) => s.match(/^<strong>([\s\S]*?)<\/strong>\s*([\s\S]*)$/));
      if (kv.every((m) => m && m[2])) {
        const dl = document.createElement("dl");
        dl.className = "rvm-kv";
        dl.innerHTML = kv.map((m) => `<div><dt>${m[1].replace(/:\s*$/, "")}</dt><dd>${m[2]}</dd></div>`).join("");
        p.replaceWith(dl);
        return;
      }
      const st = segs.map((s) => s.match(/^(\d+)\.\s+([\s\S]*)$/));
      if (st.every(Boolean)) {
        const ol = document.createElement("ol");
        ol.className = "rvm-steps";
        ol.innerHTML = st.map((m) => `<li><span class="rvm-steps__n" aria-hidden="true">${m[1].padStart(2, "0")}</span><div>${m[2]}</div></li>`).join("");
        p.replaceWith(ol);
        return;
      }
      if (/^<strong>[\s\S]*?<\/strong>$/.test(segs[0])) p.classList.add("rvm-note");
    });
  }

  const sizeFigure = () => `
    <figure class="rvm-measure" aria-label="${T("So wird gemessen", "How it is measured")}">
      <svg viewBox="0 0 300 290" aria-hidden="true">
        <path class="rvm-measure__shirt" d="M112 34 Q150 58 188 34 L246 56 L294 128 L254 152 L234 122 L234 274 L66 274 L66 122 L46 152 L6 128 L54 56 Z"/>
        <path class="rvm-measure__shirt" d="M120 37 Q150 66 180 37"/>
        <g class="rvm-measure__a"><path d="M68 132 H232"/><path d="M68 126 v12 M232 126 v12"/><circle cx="150" cy="132" r="11"/><text x="150" y="136.5">A</text></g>
        <g class="rvm-measure__b"><path d="M98 44 V270"/><path d="M92 44 h12 M92 270 h12"/><circle cx="98" cy="196" r="11"/><text x="98" y="200.5">B</text></g>
      </svg>
      <figcaption>
        <div class="rv-eyebrow">${T("So wird gemessen", "How it is measured")}</div>
        <dl><div><dt>A</dt><dd>${T("halbe Brustweite — flach liegend von Achsel zu Achsel", "half chest width — measured flat from armpit to armpit")}</dd></div><div><dt>B</dt><dd>${T("Länge", "Length")}</dd></div></dl>
      </figcaption>
    </figure>`;

  function bindService(root) {
    /* aktiven Chip in Sicht scrollen (nur horizontal) */
    const ch = root.querySelector(".rvm-chips__in"), on = ch && ch.querySelector(".is-on");
    const chipIn = () => {
      if (!ch || !on || !ch.clientWidth) return;
      const pad = parseFloat(getComputedStyle(ch).paddingLeft) || 16;
      ch.scrollLeft = Math.max(0, ch.scrollLeft + on.getBoundingClientRect().left - ch.getBoundingClientRect().left - pad);
    };
    chipIn();
    requestAnimationFrame(chipIn);
    root.addEventListener("click", (e) => {
      const g = e.target.closest("[data-go]");
      if (g) { e.preventDefault(); const t = document.getElementById(g.dataset.go); if (t) t.scrollIntoView({ behavior: still() ? "auto" : "smooth", block: "start" }); return; }
      const b = e.target.closest(".rvm-acc__b");
      if (b) { const it = b.closest(".rvm-acc__it"); const open = !it.classList.contains("is-open"); it.classList.toggle("is-open", open); b.setAttribute("aria-expanded", open); return; }
      const all = e.target.closest("[data-faq-all]");
      if (all) {
        const open = all.getAttribute("aria-pressed") !== "true";
        root.querySelectorAll("[data-faq-it]").forEach((it) => { if (it.hidden) return; it.classList.toggle("is-open", open); it.querySelector(".rvm-acc__b").setAttribute("aria-expanded", open); });
        all.setAttribute("aria-pressed", open); all.textContent = open ? T("Alle schließen", "Close all") : T("Alle öffnen", "Open all");
      }
    });
    const q = root.querySelector("[data-faq-q]");
    if (q) {
      const items = Array.from(root.querySelectorAll("[data-faq-it]")).map((it) => ({ it, s: norm(it.textContent) }));
      q.addEventListener("input", RV.debounce(() => {
        const words = norm(q.value).split(/\s+/).filter(Boolean);
        let n = 0;
        items.forEach(({ it, s }) => {
          const hit = !words.length || words.every((w) => s.includes(w));
          it.hidden = !hit;
          if (hit) n++;
          if (words.length) { it.classList.toggle("is-open", hit); it.querySelector(".rvm-acc__b").setAttribute("aria-expanded", hit); }
        });
        root.querySelectorAll(".rvm-faq__grp").forEach((g) => (g.hidden = !g.querySelector("[data-faq-it]:not([hidden])")));
        root.querySelector(".rvm-faq__none").hidden = n > 0;
        const jump = root.querySelector(".rvm-faq__jump");
        if (jump) jump.hidden = !!words.length;
      }, 120));
    }
  }

  RV.page("seite", {
    header: "solid",
    render(el, ctx) {
      const root = el.querySelector(".rvm-svc");
      if (!root) return;
      const doc = root.querySelector(".rvm-doc");
      const s = (ctx.params && ctx.params.s) || "content";
      if (doc) {
        stripEmoji(doc);
        /* Inline-Styles der Snippets (nutzten ihre entfernten :root-Farben) – Farbtupfer behalten */
        doc.querySelectorAll(".rp [style]:not(.color-swatch)").forEach((e) => e.removeAttribute("style"));
        if (s === "rv-faq") faqBuild(doc);
        if (s === "content") prepContent(doc);
        /* Tabellen einrahmen (mobil seitlich scrollbar statt Seitenüberlauf) */
        doc.querySelectorAll("table").forEach((tb) => {
          if (tb.parentElement.classList.contains("rvm-table")) return;
          const w = document.createElement("div"); w.className = "rvm-table"; tb.before(w); w.appendChild(tb);
        });
        /* Schrittnummern zweistellig wie in der Vorlage (01, 02 …) */
        doc.querySelectorAll(".step-num").forEach((n) => { const t = n.textContent.trim(); if (/^\d$/.test(t)) n.textContent = "0" + t; });
        if (s === "rv-groessentabelle") { const mg = doc.querySelector(".measure-grid"); if (mg) mg.insertAdjacentHTML("beforebegin", sizeFigure()); }
        /* Kontaktformular: Bestätigung nach dem Absenden (Shopify leitet mit ?contact_posted=true zurück) */
        if (s === "rv-kontakt" && ctx.query && ctx.query.contact_posted === "true") {
          const fs = doc.querySelector(".form-section form") || doc.querySelector(".form-section");
          if (fs && root.dataset.ok) fs.insertAdjacentHTML("afterbegin", `<p class="rvm-note rvm-ok" role="status">${esc(root.dataset.ok)}</p>`);
        }
      }
      bindService(root);
    },
  });
})();
